import { toast } from "sonner";
import { Check } from "lucide-react";

import UserAvatar from "@/components/shared/UserAvatar";
import { LoaderIcon } from "@/components/icons/LoaderIcon";

function SubscriberToastBody({ user, roles, message, icon }) {
  const roleNames = (roles ?? []).map((r) => r?.name).filter(Boolean);
  const rolesLabel = roleNames.length > 0 ? roleNames.join(", ") : "";
  return (
    <div className="flex w-full items-center gap-2">
      <UserAvatar user={user} coinOnly size="default" />
      <div className="flex min-w-0 flex-grow flex-col">
        <span className="truncate text-base">{user?.name}</span>
        <span className="truncate text-xs text-muted-foreground">
          {message}
          {rolesLabel ? ` ${rolesLabel}` : ""}
        </span>
      </div>
      {icon}
    </div>
  );
}

export function beginSubscriberToast({ user, roles, message }) {
  return toast(
    <SubscriberToastBody
      user={user}
      roles={roles}
      message={message}
      icon={<LoaderIcon className="h-5 w-5 text-primary" />}
    />,
    { duration: Infinity }
  );
}

export function completeSubscriberToast({ toastId, user, roles, message }) {
  toast(
    <SubscriberToastBody
      user={user}
      roles={roles}
      message={message}
      icon={<Check className="h-5 w-5 text-green-600" />}
    />,
    { id: toastId, duration: 4000 }
  );
}

export function failSubscriberToast({ toastId, message, description }) {
  toast.error(message, {
    id: toastId,
    description: description || "Unexpected error, please try again later.",
    duration: 4000,
  });
}
